import { buildColumnExpression } from "helpers/utils/build-column-expression";
import { Validator } from "helpers/validator";
import { formatMessage } from "lib/globalize-util";
import {
    IAttributeData,
    IAttributeDataError,
    RuleType,
} from "../../../../components/product-collection/manage-allocation-dimension/import-door-attributes/types";

export class RequiredColumnsRule extends Validator<IAttributeData[], IAttributeDataError> {
    requiredColumns: string[];

    constructor(requiredColumns: string[]) {
        super();
        this.requiredColumns = requiredColumns;
    }

    validate(model: IAttributeData[], errors: IAttributeDataError): IAttributeDataError {
        let missingColumns = [];
        if (!errors[RuleType.RequiredColumnsRule]) {
            const headers = Object.keys(model[0] || {});
            missingColumns = this.requiredColumns.reduce((acc, column) => {
                const expression = buildColumnExpression(column);

                !headers.some((header) => expression.test(header)) && acc.push(column);
                return acc;
            }, []);
        }

        const validationErrors = missingColumns.length
            ? {
                  ...errors,
                  [RuleType.RequiredColumnsRule]: formatMessage("Your file is missing required field(s): |fields|", {
                      fields: missingColumns.join(", "),
                  }),
              }
            : errors;

        return super.validate(model, validationErrors);
    }
}
